<div class="row">
  <div class="col-12 d-md-flex d-lg-flex d-xl-flex">
    <div>
      <h1>
        Buscas Salvas
      </h1>
    </div>
  </div>
</div>

<app-loader [loading]="loading"></app-loader>

<ng-container *ngIf="alerts">
  <div class="card" *ngFor="let alert of alerts">
    <div class="card-body padding-card">
      <div class="d-flex justify-content-between">

        <div>
          <a [routerLink]="['/arrematar/veiculos']" [queryParams]="alert.filter.toParamMap()" class="name">
            {{alert.name}}
          </a>
        </div>

        <div class="delete-alert" (click)="deleteAlert(alert)">
          <i class="material-icons">delete_outline</i><span>Excluir</span>
        </div>
      </div>
      <div class="send-alert-toggle">
        <mat-slide-toggle [ngModel]="!alert.inactive" (change)="toggleAlertStatus(alert)">
          <span class="alert-status"
            [ngClass]="{selected: !alert.inactive}">{{!alert.inactive ? 'Receber novas ofertas por email' : 'Não quero receber ofertas por email'}}</span>
        </mat-slide-toggle>
      </div>
      <div class="filter-details">
        <app-filter-details [filter]="alert.filter"></app-filter-details>
      </div>
      <div class="filter-details">
        Criado por {{alert.createdBy}}, em {{alert.createdAt | date: 'dd/MM/yyyy'}}
      </div>
    </div>
  </div>
</ng-container>